import script from "./TokenInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./TokenInfoCard.vue?vue&type=style&index=0&id=5fc7e4d3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc7e4d3"]])

export default __exports__